import actions from '@/core/store/permissionamento/actions'
import state from '@/core/store/permissionamento/state'
import mutations from '@/core/store/permissionamento/mutations'

export default {
	actions,
	state,
	mutations,
}
